// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../library/images/common/icons.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WQ8Woq5fqErPDFNNpLWA {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    display: block;
    position: relative;
    scale: 4;
    left: 48px;
    top: 20px;
}

.GLq_5UKbxl1KVJ1RxbQH {
    width: 30px;
    height: 15px;
    background-position: -83px 0px;
}

.FqaMF2BiOUe77nHWvDcw {
    width: 30px;
    height: 15px;
    background-position: -52px 0px;
}

.WXjo3KupWENYSGFkXEFd {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    height: 70px;
    width: 132px;
    background: rgba(234, 236, 240, 1);
    padding: 2px;
    overflow: hidden;    
}`, "",{"version":3,"sources":["webpack://./src/pages/settings/configs/config.module.css"],"names":[],"mappings":"AAAA;IACI,yDAAiE;IACjE,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".paymentsGlobalImg {\n    background-image: url('../../../library/images/common/icons.svg');\n    display: block;\n    position: relative;\n    scale: 4;\n    left: 48px;\n    top: 20px;\n}\n\n.listStyle {\n    width: 30px;\n    height: 15px;\n    background-position: -83px 0px;\n}\n\n.defaultStyle {\n    width: 30px;\n    height: 15px;\n    background-position: -52px 0px;\n}\n\n.imgWrapper {\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 8px;\n    height: 70px;\n    width: 132px;\n    background: rgba(234, 236, 240, 1);\n    padding: 2px;\n    overflow: hidden;    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentsGlobalImg": `WQ8Woq5fqErPDFNNpLWA`,
	"listStyle": `GLq_5UKbxl1KVJ1RxbQH`,
	"defaultStyle": `FqaMF2BiOUe77nHWvDcw`,
	"imgWrapper": `WXjo3KupWENYSGFkXEFd`
};
export default ___CSS_LOADER_EXPORT___;
